import { __assign, __rest } from "tslib";
import React from 'react';
import { Avatar } from 'wix-style-react';
// legacy wix code uses gravatar as default profile image for new users (email signup)
// gravatar image urls might have a default query param d=blank
// if the user never used gravatar, a blank image is returned as default
// wsr avatar component doesnt handle this well, and treats it as a normal image
// which results in an empty avatar and not showing initials or even a placeholder
// changing to d=404 in image url query params results in expected behavior
var handleGravatarImageURL = function (src) {
    if (src) {
        if (typeof URL !== 'undefined') {
            try {
                var imgUrl = new URL(src);
                if (imgUrl.host.indexOf('gravatar.com') !== -1) {
                    imgUrl.searchParams.set('d', '404');
                    return imgUrl.toString();
                }
            }
            catch (urlParseEx) {
                // could not parse url
                console.warn('Avatar Wrapper: could not parse avatar url', src);
                return null;
            }
        }
        else if (src.indexOf('gravatar.com') !== -1) {
            // if no URL support
            return src.replace('d=blank', 'd=404');
        }
    }
    return null;
};
var AvatarWrapper = function (_a) {
    var _b = _a.imgProps, imgProps = _b === void 0 ? {} : _b, rest = __rest(_a, ["imgProps"]);
    var imageUrl = imgProps === null || imgProps === void 0 ? void 0 : imgProps.src;
    // if no image url or is not gravatar, returns null
    var gravatarUrl = handleGravatarImageURL(imageUrl);
    var src = gravatarUrl || imageUrl;
    return (React.createElement(Avatar, __assign({ imgProps: src ? __assign(__assign({}, imgProps), { src: src }) : undefined }, rest)));
};
export default AvatarWrapper;
//# sourceMappingURL=AvatarWrapper.js.map